import React from 'react';

import  HeaderInfoTooltip  from '../HeaderInfoTooltip/HeaderInfoTooltip';

const missing =
  'https://cdn.app.corsicatech.com/assets/images/patching_missing.svg';
const needsReboot =
  'https://cdn.app.corsicatech.com/assets/images/patching_needs_reboot.svg';
const notPatching =
  'https://cdn.app.corsicatech.com/assets/images/patching_not_patching.svg';
const unscanned =
  'https://cdn.app.corsicatech.com/assets/images/patching_unscanned.svg';

export const StatusIcon = ({ status, ...otherProps }) => {
  let icon;
  let description = '';
  switch (status) {
    case 'Not Configured':
      icon = <img src={notPatching} {...otherProps} alt="Not Configured" />;
      description = 'Not configured correctly for patch management';
      break;
    case 'Unscanned':
      icon = <img src={unscanned} {...otherProps} alt="Unscanned" />;
      description = 'Not checked in with our patching service in over 10 days';
      break;
    case 'Reboot Needed':
    case 'Needs to be Rebooted':
      icon = <img src={needsReboot} {...otherProps} alt="Reboot Needed" />;
      description =
        'Needs to be rebooted for patch installation to be completed';
      break;
    case 'Missing Patches':
      icon = <img src={missing} {...otherProps} alt="Missing Patches" />;
      description = 'Missing patches';
      break;
    default:
  }
  return status && status !== 'Current' ? (
    <HeaderInfoTooltip content={description}>{icon}</HeaderInfoTooltip>
  ) : null;
};

export default StatusIcon;
